function hasReachedTarget(origin, target, current) {
  return origin < target && current >= target || origin > target && current <= target;
}
export { hasReachedTarget };